export default [
  // 添加编辑课程名称
  {
    name: 'cu-course-name',
    component: () => import(/* webpackChunkName: "cu-course-name" */ './cu-course-name.vue'),
  },
];
